import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {graphql} from 'react-apollo';
import mutateProps from 'utils/mutateProps';

import {query, mutation, onboardProps, onboardedBankAccount as onboarded} from 'flows/account/bank';
import config from 'config';

import Spinner from 'components/Spinner';
import Page from 'components/Page';
import ReactPlaid, { SANDBOX_ENV, PROD_ENV, AUTH_PRODUCT } from "react-plaid";
import BankAccount from './component';

import './style.css';

export class BankAccountContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      saving: false,
    }
    this.link = this.link.bind(this);
    this.onboard = this.onboard.bind(this);
    this.plaidEvent = this.plaidEvent.bind(this);
  }
  link() {
    this.setState({open: true});
  }
  onboard(token, metadata) {
    this.setState({saving: true, open: false});
    this.props.onboard(metadata)
      .then(this.props.data.refetch)
      .then(() => {this.props.onboarded({account: this.props.onboardResult.data.sources})})
      .then(() => {this.setState({saving: false})});
  }
  plaidEvent(eventName, metadata) {
    window.mixpanel.track(`plaid_${eventName}`, metadata);
  }
  render() {
    const {data: {loading, userinfo}} = this.props;
    if (loading || this.state.saving) {
      return (
        <Page styleName="loadContainer">
          <Spinner />
        </Page>
      );
    }

    return (
      <section>
        <ReactPlaid
          clientName="Cove"
          product={[AUTH_PRODUCT]}
          apiKey={config.plaid.apiKey}
          env={config.plaid.env}
          open={this.state.open}
          onSuccess={this.onboard}
          onEvent={this.plaidEvent}
          onExit={() => this.setState({open: false})}
        />
        {
          this.state.token
        }
        <BankAccount userinfo={userinfo} link={this.link}/>
      </section>
    );
  }
}

BankAccountContainer.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    userinfo: PropTypes.object,
    refetch: PropTypes.func.isRequired,
  }).isRequired,
  onboard: PropTypes.func.isRequired,
  onboarded: PropTypes.func.isRequired,
};

const mapMutation = props => {
  return {
    onboard: onboardProps(props),
  }
};

export default compose(
  connect(null, {onboarded}),
  graphql(query),
  graphql(mutation, {
    props: mapMutation,
  }),
  mutateProps({name: 'onboard'}),
)(BankAccountContainer);



// WEBPACK FOOTER //
// ./web/flows/account/components/BankAccount/index.js